// id
export const CREATED_BY = 'Dibuat oleh';
export const THREAD = 'Lembaran';
export const EMPTY_MESSAGE_ACTIVE_THREADS = 'Tidak Ada Lembaran yang aktif';
export const EMPTY_MESSAGE_LEADERBOARDS = 'Tidak Ada Papan Peringkatn';
export const LOADING_THREAD = 'Memuat Lembaran...';
export const LOADING_LEADERBOARD = 'Memuat Papan Peringkat...';
export const LEADERBOARD = 'Papan Peringkat';
export const PLACEHOLDER_SEARCH_INPUT = 'Cari berdasarkan judul ...';
export const PLACEHOLDER_TITLE_ADD_THREAD = 'Judul Lembaran';
export const PLACEHOLDER_TITLE_BODY_THREAD = 'Tuliskan Lembaran kamu diini...';
export const POPULAR_CATEGORY = 'Popular Category';
export const TEXT_MODAL_DELETE = 'Berhasil hapus catatan...';
export const TEXT_MODAL_ADD = 'Berhasil tambah catatan...';
export const TEXT_MODAL_ARCHIVE = 'Berhasil arsipkan catatan...';
export const TEXT_MODAL_UNARCHIVE = 'Berhasil aktifkan catatan...';
export const TEXT_MODAL_REGISTER_FAIL = 'Maaf, Password dan Confirm Password harus sama.';
export const TEXT_MODAL_REGISTER_SUCCESS = 'Selamat, Berhasil membuat Akun.';
export const TITLE_BUTTON_ADD = 'Tambah';
export const TITLE_BUTTON_SAVE = 'Simpan';
export const TITLE_BUTTON_ARCHIVE = 'Arsipkan';
export const TITLE_BUTTON_ACTIVE = 'Aktifkan';
export const TITLE_BUTTON_DELETE = 'Hapus';
export const TITLE_BUTTON_LOGIN = 'Masuk';
export const TITLE_COMMENT = 'Komentar';
export const TITLE_GIVE_COMMENT = 'Beri Komentar';
export const TITLE_CONFIRM_PASSWORD = 'Konfirmasi Kata Sandi';
export const TITLE_EMAIL = 'Surel';
export const TITLE_LOGIN = 'Yuk, login untuk menggunakan aplikasi.';
export const TITLE_LOGIN_HERE = 'Masuk disini';
export const TITLE_LOGIN_NO_ACCOUNT = 'Belum punya akun?';
export const TITLE_MODAL_DELETE = 'Oops...';
export const TITLE_MODAL_ADD = 'Tambah Catatan';
export const TITLE_MODAL_ARCHIVE = 'Archive Catatan';
export const TITLE_MODAL_UNARCHIVE = 'Aktifkan Catatan';
export const TITLE_NAME = 'Nama';
export const TITLE_FORUM_APPS = 'Aplikasi Forum Dicoding';
export const TITLE_PASSWORD = 'Kata Sandi';
export const TITLE_REGISTER = 'Daftar';
export const TITLE_REGISTER_FAIL = 'Gagal Daftar';
export const TITLE_REGISTER_HERE = 'Datar di sini.';
export const TITLE_REGISTER_HAVE_ACCOUNT = 'Sudah punya akun?';
export const TITLE_REGISTER_TITLE = 'Isi form untuk mendaftar akun..';
export const TITLE_REGISTER_SUCCESS = 'Berhasil Daftar Akun';
export const TITLE_SEND = 'Kirim';

// en
export const CREATED_BY_EN = 'Created by';
export const THREAD_EN = 'Thread';
export const EMPTY_MESSAGE_ACTIVE_THREADS_EN = 'No Active Threads';
export const EMPTY_MESSAGE_LEADERBOARDS_EN = 'No Leaderboards';
export const LOADING_THREAD_EN = 'Loading Threads...';
export const LOADING_LEADERBOARD_EN = 'Loading Leaderboards...';
export const LEADERBOARD_EN = 'Leaderboard';
export const PLACEHOLDER_SEARCH_INPUT_EN = 'Search by title ...';
export const PLACEHOLDER_TITLE_ADD_THREAD_EN = 'Title Thread';
export const PLACEHOLDER_TITLE_BODY_THREAD_EN = 'Write your Thread here...';
export const POPULAR_CATEGORY_EN = 'Kategori Popular';
export const TEXT_MODAL_REGISTER_FAIL_EN = 'Sorry, Password and Confirm Password must be the same.';
export const TEXT_MODAL_REGISTER_SUCCESS_EN = 'Congratulations, Successfully created an Account.';
export const TITLE_BUTTON_ADD_EN = 'Plus';
export const TITLE_BUTTON_SAVE_EN = 'Save';
export const TITLE_BUTTON_ARCHIVE_EN = 'Archive';
export const TITLE_BUTTON_ACTIVE_EN = 'Activate';
export const TITLE_BUTTON_DELETE_EN = 'Delete';
export const TITLE_BUTTON_LOGIN_EN = 'Login';
export const TITLE_COMMENT_EN = 'Comment';
export const TITLE_GIVE_COMMENT_EN = 'Write a comment';
export const TITLE_CONFIRM_PASSWORD_EN = 'Confirm Password';
export const TITLE_EMAIL_EN = 'Email';
export const TITLE_LOGIN_EN = 'Login to use app, please.';
export const TITLE_LOGIN_HERE_EN = 'Login here';
export const TITLE_LOGIN_NO_ACCOUNT_EN = "Don't have an account?";
export const TITLE_MODAL_DELETE_EN = 'Oops...';
export const TITLE_NAME_EN = 'Name';
export const TITLE_FORUM_APPS_EN = 'Dicoding Forum Apps';
export const TITLE_PASSWORD_EN = 'Password';
export const TITLE_REGISTER_EN = 'Register';
export const TITLE_REGISTER_FAIL_EN = 'Register Failed';
export const TITLE_REGISTER_HERE_EN = 'Register here';
export const TITLE_REGISTER_HAVE_ACCOUNT_EN = 'Already have an account?';
export const TITLE_REGISTER_TITLE_EN = 'Fill in the form to register an account..';
export const TITLE_REGISTER_SUCCESS_EN = 'Account Register Success';
export const TITLE_SEND_EN = 'Send';

// common
export const BASE_URL = 'https://forum-api.dicoding.dev/v1';
export const BG_COLOR_BLACK = '#202124';
export const CODE_PAGE_NOT_FOUND = '404';
export const ICON_ERROR = 'error';
export const ICON_SUCCESS = 'success';
export const KEYWORD_SEARCH_TITLE = 'keyword';
export const PAGE_NOT_FOUND = 'Halaman tidak ditemukan';
export const PAGE_NOT_FOUND_EN = 'Page not found';
export const URL_LEADERBOARD = '/leaderboard';
export const URL_ADD_THREAD = '/add';
export const URL_HOME = '/';
export const URL_LOGIN = '/login';
export const URL_THREAD_DETAIL = '/threads';
export const URL_REGISTER = '/register';
export const WHITE_COLOR = 'white';

// set action
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const SET_CLEAR_THREAD_DETAIL = 'SET_CLEAR_THREAD_DETAIL';
export const SET_CREATE_COMMENT = 'SET_CREATE_COMMENT';
export const SET_CREATE_THREAD = 'SET_CREATE_THREAD';
export const SET_IS_PRELOAD = 'SET_IS_PRELOAD';
export const SET_DOWN_VOTE_COMMENT = 'SET_DOWN_VOTE_COMMENT';
export const SET_DOWN_VOTE_THREAD = 'SET_DOWN_VOTE_THREAD';
export const SET_DOWN_VOTE_THREAD_DETAIL = 'SET_DOWN_VOTE_THREAD_DETAIL';
export const SET_NEUTRAL_VOTE_COMMENT = 'SET_NEUTRAL_VOTE_COMMENT';
export const SET_NEUTRAL_VOTE_THREAD = 'SET_NEUTRAL_VOTE_THREAD';
export const SET_NEUTRAL_VOTE_THREAD_DETAIL = 'SET_NEUTRAL_VOTE_THREAD_DETAIL';
export const SET_UP_VOTE_COMMENT = 'SET_UP_VOTE_COMMENT_VOTE';
export const SET_UP_VOTE_THREAD = 'SET_UP_VOTE_THREAD';
export const SET_UP_VOTE_THREAD_DETAIL = 'SET_UP_VOTE_THREAD_DETAIL';
export const SET_RECEIVE_LEADERBOARDS = 'SET_RECEIVE_LEADERBOARDS';
export const SET_RECEIVE_THREAD = 'SET_RECEIVE_THREAD';
export const SET_RECEIVE_THREAD_DETAIL = 'SET_RECEIVE_THREAD_DETAIL';
export const SET_RECEIVE_USERS = 'SET_RECEIVE_USERS';
export const UNSET_AUTH_USER = 'UNSET_AUTH_USER';

// fake data for testing reducer
export const STATE_OBJECT_SET_UNSET_AUTH_USER = {
  id: 'user-123',
  name: 'Hanagaki Takemichi',
  email: 'takemichi@mail.com',
  avatar: 'https://tokyo-revengers.com/takemichi-image.jpg',
};
export const STATE_ARRAY_RECEIVE_LEADERBOARDS = [
  {
    user: {
      id: 'user-123',
      name: 'Hanagaki Takemichi',
      email: 'takemichi@mail.com',
      avatar: 'https://tokyo-revengers.com/takemichi-image.jpg',
    },
    score: 150,
  },
  {
    user: {
      id: 'user-124',
      name: 'Mikey',
      email: 'mikey@mail.com',
      avatar: 'https://tokyo-revengers.com/mikey-image.jpg',
    },
    score: 140,
  },
  {
    user: {
      id: 'user-125',
      name: 'Kisakki Tetta',
      email: 'kisakki@mail.com',
      avatar: 'https://tokyo-revengers.com/kisakki-image.jpg',
    },
    score: 70,
  },
];
export const STATE_ARRAY_RECEIVE_THREADS = [
  {
    id: 'thread-123',
    title: 'thread-pertama',
    body: 'halo guys ini thread pertamaku, silahkan membaca',
    category: 'tokyo-revengers',
    createdAt: '2023-02-08T16:20:12.401Z',
    ownerId: 'user-123',
    totalComments: 2,
    upVotesBy: [
      'user-123',
    ],
    downVotesBy: [
      'user-124',
      'user-124',
    ],
  },
  {
    id: 'thread-124',
    title: 'thread-kedua',
    body: 'halo guys ini thread keduaku, silahkan membaca',
    category: 'random thread',
    createdAt: '2023-02-11T11:40:12.401Z',
    ownerId: 'user-124',
    totalComments: 7,
    upVotesBy: [
      'user-124',
    ],
    downVotesBy: [
      'user-123',
    ],
  },
  {
    id: 'thread-125',
    title: 'thread-ketiga',
    body: 'halo guys ini thread ketigaku, silahkan membaca',
    category: 'vue',
    createdAt: '2023-01-12T17:10:12.401Z',
    ownerId: 'user-125',
    totalComments: 2,
    upVotesBy: [
      'user-123',
      'user-124',
      'user-124',
    ],
    downVotesBy: [],
  },
];
export const STATE_THREAD_ID = 'thread-KajIq19Ao1s-2sda';
export const STATE_USER_ID = 'user-_C90fzJ33G2nNlLK';
export const STATE_OBJECT_THREAD = [
  {
    id: 'thread-KajIq19Ao1s-2sda',
    title: 'test-1',
    body: 'test 123',
    ownerId: 'user-_C90fzJ33G2nNlLK',
    createdAt: '2023-02-08T14:31:41.259Z',
    totalComments: 0,
    upVotesBy: [],
    downVotesBy: [],
  },
];

export const STATE_OBJECT_SET_CREATE_THREAD_CREATED = {
  id: 'thread-MS0zEiQWFt2-CfJq',
  title: 'test-1',
  body: 'test 123',
  ownerId: 'user-_ksaokA(s9e2',
  createdAt: '2023-02-08T14:32:41.259Z',
  totalComments: 0,
  upVotesBy: [],
  downVotesBy: [],
};

export const STATE_OBJECT_SET_RECEIVE_THREAD_DETAIL = {
  id: 'thread-1',
  title: 'Thread Pertama',
  body: 'Ini adalah thread pertama',
  category: 'General',
  createdAt: '2021-06-21T07:00:00.000Z',
  owner: {
    id: 'users-1',
    name: 'John Doe',
    avatar: 'https://generated-image-url.jpg',
  },
  upVotesBy: [],
  downVotesBy: [],
  comments: [
    {
      id: 'comment-1',
      content: 'Ini adalah komentar pertama',
      createdAt: '2021-06-21T07:00:00.000Z',
      owner: {
        id: 'users-1',
        name: 'John Doe',
        avatar: 'https://generated-image-url.jpg',
      },
      upVotesBy: [],
      downVotesBy: [],
    },
  ],
};

export const STATE_COMMENT_ID = 'comment-1';
export const STATE_OBJECT_COMMENT = {
  id: 'comment-1',
  content: 'Ini adalah komentar pertama',
  createdAt: '2021-06-21T07:00:00.000Z',
  upVotesBy: [],
  downVotesBy: [],
  owner: {
    id: 'users-1',
    name: 'John Doe',
    email: 'john@example.com',
  },
};

export const STATE_ARRAY_SET_RECEIVE_USERS = [
  {
    user: {
      id: 'user-123',
      name: 'Hanagaki Takemichi',
      email: 'takemichi@mail.com',
      avatar: 'https://tokyo-revengers.com/takemichi-image.jpg',
    },
    score: 150,
  },
  {
    user: {
      id: 'user-124',
      name: 'Mikey',
      email: 'mikey@mail.com',
      avatar: 'https://tokyo-revengers.com/mikey-image.jpg',
    },
    score: 140,
  },
];

// fake data for testing thunk
export const FAKE_EMAIL_USER = 'odlareg@mail.com';
export const FAKE_PASSWORD_USER = '123456';
export const FAKE_TOKEN = 'token-123456';
export const FAKE_RESPONSE_USER_LOGGED = {
  id: 'user-1',
  name: 'odlareg',
  email: 'odlareg@mail.com',
  avatar: 'https://ui-avatars.com/api/?name=odlareg&background=random',
};
export const FAKE_ERROR_RESPONSE_MESSAGE = new Error('Ups, something went wrong');

export const FAKE_RESPONSE_CREATE_COMMENT = {
  id: 'comment-7xESFSNCbZQx6K1Q',
  content: 'mantap bang lanjutkan<br>',
  createdAt: '2023-02-09T03:42:19.471Z',
  upVotesBy: [],
  downVotesBy: [],
  owner: {
    id: 'user-_C90fzJ33G2nNlLK',
    name: 'geraldo',
    email: 'geraldos@mail.com',
    avatar: 'https://ui-avatars.com/api/?name=geraldo&background=random',
  },
};
export const FAKE_THREAD_ID = 'thread-12345';
export const FAKE_BODY_COMMENT = 'mantap bang lanjutkan';

export const FAKE_COMMENT_ID = 'comment-12345';
export const FAKE_STATE_AUTH_USER = {
  id: 'user-_C90fzJ33G2nNlLK',
  name: 'geraldo',
  email: 'geraldos@mail.com',
  avatar: 'https://ui-avatars.com/api/?name=geraldo&background=random',
};

export const FAKE_STATE_THREAD_DETAIL = {
  id: 'thread-EeBEWzPJnSbAFyY9',
  title: 'test',
  body: 'test',
  createdAt: '2023-02-09T04:00:36.022Z',
  owner: {
    id: 'user-_C90fzJ33G2nNlLK',
    name: 'naruto uzumaki',
    avatar: 'https://ui-avatars.com/api/?name=naruto uzumaki&background=random',
  },
  category: 'test',
  comments: [
    {
      id: 'comment-12345',
      content: 'test',
      createdAt: '2023-02-09T04:00:48.027Z',
      owner: {
        id: 'user-_C90fzJ33G2nNlLK',
        name: 'naruto uzumaki',
        avatar: 'https://ui-avatars.com/api/?name=naruto uzumaki&background=random',
      },
      upVotesBy: [],
      downVotesBy: [],
    },
  ],
  upVotesBy: [],
  downVotesBy: [
    'user-AWTUTO0o7wbVF0X4',
  ],
};

export const FAKE_RESPONSE_DOWN_COMMENT_VOTE = {
  id: 'comment-12345',
  commentId: 'comment-GhKhLlpb909B_SkM',
  userId: 'user-AWTUTO0o7wbVF0X4',
  voteType: -1,
};

export const FAKE_RESPONSE_NEUTRAL_COMMENT_VOTE = {
  id: 'comment-12345',
  commentId: 'comment-GhKhLlpb909B_SkM',
  userId: 'user-AWTUTO0o7wbVF0X4',
  voteType: 0,
};

export const FAKE_RESPONSE_UP_COMMENT_VOTE = {
  id: 'comment-12345',
  commentId: 'comment-GhKhLlpb909B_SkM',
  userId: 'user-AWTUTO0o7wbVF0X4',
  voteType: 1,
};

export const FAKE_RESPONSE_GET_ALL_LEADERBOARD = [
  {
    user: {
      id: 'user-123',
      name: 'Takemichi',
      email: 'takemichi@dicoding.com',
      avatar: 'https://ui-avatars.com/api/?name=takemichi Saputra&background=random',
    },
    score: 55,
  },
  {
    user: {
      id: 'user-1234',
      name: 'mikey',
      email: 'mikey@dicoding.com',
      avatar: 'https://ui-avatars.com/api/?name=mikey&background=random',
    },
    score: 15,
  },
  {
    user: {
      id: 'user-12345',
      name: 'kisakki',
      email: 'kisakki@gmail.com',
      avatar: 'https://ui-avatars.com/api/?name=kisakki&background=random',
    },
    score: 0,
  },
];

export const FAKE_RESPONSE_GET_ALL_THREAD = [
  {
    id: 'thread-123',
    title: 'test thread pertamaku',
    body: 'halo guys ini thread pertama ku hehe',
    category: 'thread',
    createdAt: '2022-11-13T09:59:31.019Z',
    ownerId: 'user-123',
    totalComments: 1,
    upVotesBy: [
      'user-1234',
      'user-12345',
    ],
    downVotesBy: [],
  },
  {
    id: 'thread-1234',
    title: 'Halo gengs ini status pertama ku',
    body: 'gimana gens keren kan statusku?',
    category: 'status',
    createdAt: '2022-11-13T09:55:55.353Z',
    ownerId: 'user-1234',
    totalComments: 1,
    upVotesBy: [
      'user-123',
      'user-1234',
    ],
    downVotesBy: [],
  },
];

export const FAKE_RESPONSE_GET_ALL_USER = [
  {
    id: 'user-123',
    name: 'Takemichi',
    email: 'takemichi@dicoding.com',
    avatar: 'https://ui-avatars.com/api/?name=takemichi Saputra&background=random',

  },
  {
    id: 'user-1234',
    name: 'mikey',
    email: 'mikey@dicoding.com',
    avatar: 'https://ui-avatars.com/api/?name=mikey&background=random',
  },
];

export const FAKE_TITLE_CREATE_THREAD = 'testtest';
export const FAKE_BODY_CREATE_THREAD = 'test test 123';
export const FAKE_CATEGORY_CREATE_THREAD = 'general';
export const FAKE_RESPONSE_CREATE_THREAD = {
  id: 'thread-12345',
  title: 'testtest',
  body: 'test test 123<br>',
  ownerId: 'user-_123',
  category: 'general',
  createdAt: '2023-02-09T07:30:55.669Z',
  totalComments: 0,
  upVotesBy: [],
  downVotesBy: [],
};

export const FAKE_RESPONSE_DOWN_VOTE_THREAD = {
  id: 'thread_vote-1232321',
  threadId: 'thread-12345',
  userId: 'user-_123',
  voteType: -1,
};
export const FAKE_RESPONSE_NEUTRAL_VOTE_THREAD = {
  id: 'thread_vote-1232321',
  threadId: 'thread-12345',
  userId: 'user-_123',
  voteType: 0,
};
export const FAKE_RESPONSE_UP_VOTE_THREAD = {
  id: 'thread_vote-1232321',
  threadId: 'thread-12345',
  userId: 'user-_123',
  voteType: 1,
};

export const FAKE_RESPONSE_THREAD_DETAIL = {
  id: 'thread-123',
  title: 'test',
  body: 'test test 123 <br> test',
  createdAt: '2022-11-13T09:55:55.353Z',
  owner: {
    id: 'user-123',
    name: 'takemichi',
    avatar: 'https://ui-avatars.com/api/?name=takemichig&background=random',
  },
  category: 'introduction',
  comments: [
    {
      id: 'comment-1234',
      content: 'Halo! Saya mikey, dari Jepang.',
      createdAt: '2022-11-13T09:57:52.762Z',
      owner: {
        id: 'user-1234',
        name: 'mikey',
        avatar: 'https://ui-avatars.com/api/?name=mikey&background=random',
      },
      upVotesBy: [
        'user-123',
      ],
      downVotesBy: [],
    },
  ],
  upVotesBy: [
    'user-1234',
    'user-12345',
  ],
  downVotesBy: [],
};

export const FAKE_RESPONSE_REGISTER = {
  id: 'user-zNxMPG6frwL5PXUk',
  name: 'geraldos',
  email: 'geral@mail.com',
  avatar: 'https://ui-avatars.com/api/?name=geraldos&background=random',
};
export const FAKE_EMAIL_REGISTER = 'takemichi22@gmail.com';
export const FAKE_PASSWORD_REGISTER = '123456';
export const FAKE_NAME_REGISTER = 'takemichi';
